import usePage from './use-page';
import { useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { SCREEN_RESIZE_MEDIA_QUERY } from '../types';

const usePageViewAutoSwitch = () => {
  const [{ lockForOnePageView }, { setLockForOnePageView }] = usePage();
  const isPortraitMode = useMediaQuery(SCREEN_RESIZE_MEDIA_QUERY.PORTRAIT);

  useEffect(() => {
    if (isPortraitMode !== lockForOnePageView) {
      setLockForOnePageView(isPortraitMode);
    }
  }, [isPortraitMode, lockForOnePageView]);
};

export default usePageViewAutoSwitch;
